<h1 mat-dialog-title class="text-center mb-1" *ngIf="!edit">Agregar novedad</h1>
<h1 mat-dialog-title class="text-center mb-1" *ngIf="edit">Modificar novedad</h1>

<div mat-dialog-content>
  <form [formGroup]="novedadesForm">

    <!-- Texto -->
    <mat-form-field appearance="fill" class="w-100 mb-3">
      <textarea
        matInput
        formControlName="texto"
        placeholder="Texto de la novedad*"
        rows="3"
        style="resize: none"
      ></textarea>
    </mat-form-field>
    <div class="alert alert-danger p-1 m-1" *ngIf="novedadesForm.get('texto')?.invalid && submitted">
      <p class="m-0 p-0" *ngIf="novedadesForm.get('texto')?.hasError('required')">
        Debe ingresar texto
      </p>
    </div>

    <!-- Fechas -->
    <div class="row">
      <div class="col-md-6">
        <mat-form-field appearance="fill" class="w-100 mb-3">
          <mat-label>Fecha de publicación</mat-label>
          <input
            matInput
            [min]="fecha_min_fp"
            [matDatepicker]="fechaPublicacionPicker"
            formControlName="fecha_publicacion"
            required
            (dateChange)="actualizarFechaFin($event)"
          />
          <mat-datepicker-toggle matSuffix [for]="fechaPublicacionPicker"></mat-datepicker-toggle>
          <mat-datepicker #fechaPublicacionPicker></mat-datepicker>
        </mat-form-field>
        <div class="alert alert-danger p-1 m-1" *ngIf="novedadesForm.get('fecha_publicacion')?.invalid && submitted">
          <p class="m-0 p-0" *ngIf="novedadesForm.get('fecha_publicacion')?.hasError('required')">
            Debe poseer fecha de publicación
          </p>
        </div>
      </div>

      <div class="col-md-6">
        <mat-form-field appearance="fill" class="w-100 mb-3">
          <mat-label>Fecha fin de publicación</mat-label>
          <input
            matInput
            [min]="fecha_min_ff"
            [matDatepicker]="fechaFinPicker"
            formControlName="fecha_fin"
          />
          <mat-datepicker-toggle matSuffix [for]="fechaFinPicker"></mat-datepicker-toggle>
          <mat-datepicker #fechaFinPicker></mat-datepicker>
        </mat-form-field>
        <div class="alert alert-danger p-1 m-1" *ngIf="errorFechaFin && submitted">
          <p class="m-0 p-0">Fecha fin no puede ser anterior a fecha de publicación</p>
        </div>
      </div>
    </div>

  </form>
</div>

<div mat-dialog-actions class="justify-content-center mb-1">
  <button mat-raised-button color="warn" (click)="cancelar()">Cancelar</button>
  <button mat-raised-button color="primary" (click)="onSubmit()">Confirmar</button>
  <mat-spinner diameter="22" [hidden]="!loading" style="display:inline-block; margin-left:5%;"></mat-spinner>
</div>
